export default "__VITE_ASSET__DUkPRxXE__"